<template>
    <div class="justify-content-center mb-5" style="overflow-x: hidden;">
        <div class="row justify-content-center">
            <div class="col-md-5 my-4">
                <div class="mx-auto my-3" style="width: 250px;">
                    <select
                        class="form-control-4"
                        style="font-size: 11px; max-width: 250px; text-transform: capitalize; border: 1px solid rgba(187, 134, 252, .2)!important;"
                        v-model="website">
                        <option value="null" disabled>Website</option>
                        <option v-for="(website, index) in websites" :key="index" :value="website">{{ website.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-md-10 text-center mx-auto">
            <p class="fts-28 light-white-03" style="font-weight: 900;">Liste des investisseurs</p>
        </div>
        <div class="row justify-content-center" v-for="(investor, index) in website.investors" :key="index">
            <div class="col-md-10 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
                <div style="width: 90%;">
                    <p class="fts-18 light-blue-01" style="font-weight: 900;">{{ investor.name }}</p>
                    <div class="row justify-content-center" v-for="(trade, index1) in investor.trades" :key="index1">
                        <div v-if="trade.length != 0">
                            <p class="light-white-03">Name : {{ trade.security.name }}</p>
                            <p class="light-white-03">Secteur : {{ trade.security.sector.name_french }}</p>
                            <p class="light-white-03">ISIN : {{ trade.security.isin }}</p>
                            <p class="light-white-03">Date : {{ trade.date }}</p>
                            <p class="light-white-03">Order type : {{ trade.order_type}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'websites',
            'token',
            'route',
        ],

        data() {
            return {
                website: this.websites[0],
            }
        },
        methods: {
        },
    }

</script>